<div class="container-row">
  <div class="container">
    @if ((claims.EditHelpLibrary | systemPermission) && activeHelpItem && activeHelpItem.id) {
      <div class="action-bar">
        <ng-container>
          <button role="button" attr.aria-label="Edit Help: {{activeHelpItem.name}}" (click)="editHelp(activeHelpItem.id, activeHelpItem.categoryId)" [ngClass]="{'active': isEditingHelp }">
            <svg-icon title="Edit" icon="icon-page-edit" class="dark-grey pointer" aria-hidden="true"></svg-icon>
          </button>
          <button role="button" attr.aria-label="Delete Help: {{activeHelpItem.name}}" (click)="deleteHelp()">
            <svg-icon title="Delete" icon="icon-trash" class="dark-gray pointer" aria-hidden="true"></svg-icon>
          </button>
        </ng-container>
      </div>
    }
    @if (!activeHelpItem) {
      <h3 class="h4 bold">No topic selected!</h3>
      <p>Please select a help topic from the list on the left.  If you are on a mobile device, select the tab to view the available help topics.</p>
    }
    <div class="content-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
